import React from 'react';
import { motion } from 'framer-motion';

const IMG = 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwbGl2ZSUyMGV2ZW50JTIwY3Jvd2QlMjBjb25jZXJ0JTIwbHV4dXJ5fGVufDB8fHx8MTc4MzEwOTY1M3ww&ixlib=rb-4.1.0&q=85';

// Full-width cinematic image break — design cue from luxury brochures.
export const ImageBreak = () => {
    return (
        <section data-testid="image-break" className="relative h-[60vh] min-h-[420px] overflow-hidden">
            <motion.div
                initial={{ scale: 1.15 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 2, ease: [0.22, 1, 0.36, 1] }}
                className="absolute inset-0"
            >
                <img
                    src={IMG}
                    alt="Live event moment"
                    className="w-full h-full object-cover"
                    style={{ filter: 'brightness(0.55) contrast(1.15) saturate(1.1)' }}
                />
            </motion.div>

            {/* Overlays */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black" />
            <div className="grain-overlay" />

            {/* Corner rules */}
            <div className="absolute top-8 left-8 w-16 h-px bg-gold" />
            <div className="absolute top-8 left-8 h-16 w-px bg-gold" />
            <div className="absolute bottom-8 right-8 w-16 h-px bg-gold" />
            <div className="absolute bottom-8 right-8 h-16 w-px bg-gold" />

            {/* Decorative lightning bolt SVG — echoes the brand mark */}
            <svg
                className="absolute right-[8%] top-1/2 -translate-y-1/2 h-40 w-auto opacity-20 hidden md:block"
                viewBox="0 0 40 100"
                fill="none"
                aria-hidden="true"
            >
                <path
                    d="M22 2 L8 52 L18 52 L14 98 L32 42 L22 42 Z"
                    stroke="#C9A227"
                    strokeWidth="0.8"
                    fill="rgba(201,162,39,0.15)"
                />
            </svg>

            {/* Minimal typographic marker */}
            <div className="container-lux relative z-10 h-full flex items-end pb-16">
                <div className="flex items-center gap-6">
                    <div className="w-16 h-px bg-gold" />
                    <div className="text-[10px] tracking-[0.4em] uppercase text-gold font-medium">
                        Cinematic Production
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImageBreak;
